/** @Developer be careful what you import here, it will affect every SF page */
import React, { PropsWithChildren, useEffect } from "react";
import { Toaster } from "@clarkinc/zest-design-system/ui";
import { GdprBannerModal } from "~/common/GdprBanner";
import tracker from "~/tracker";
import userPageHistoryTracking from "./userPageHistoryTracking";
import { loadUserAnalytics } from "~/gtm";
import "~/less/_critical/include.less";
import "~/css/tailwind.css";
import "~/fonts/fontello/css/fontello-top.less";
import "@clarkinc/zest-design-system/style.css";
/** Used in conjunction with SWC and BrowserList
 * @see {@link https://swc.rs/docs/configuration/supported-browsers#mode SWC Docs}
 */
import "core-js";
/** Manually added due to the following issue.
 * @see {@link https://github.com/swc-project/swc/issues/7083 Github Issue}
 */
import "core-js/actual/array/at";
import Analytics from "./analytics/Analytics";
export default function App({
  children
}: PropsWithChildren<unknown>): JSX.Element {
  useEffect(tracker);
  useEffect(() => {
    userPageHistoryTracking();
  }, []);
  useEffect(function initUserAnalytics() {
    if (!window.location.pathname.includes("cloudflareerror")) {
      loadUserAnalytics();
    }
  }, []);
  return <>
      {children}
      <GdprBannerModal data-sentry-element="GdprBannerModal" data-sentry-source-file="App.tsx" />
      <Analytics data-sentry-element="Analytics" data-sentry-source-file="App.tsx" />
      <Toaster data-sentry-element="Toaster" data-sentry-source-file="App.tsx" />
    </>;
}